import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import ValidadoLogo from '../components/ValidadoLogo';

const RegisterPage: React.FC = () => {
  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          <ValidadoLogo width={200} height={80} />
          <Typography variant="h4" sx={{ mt: 2 }}>Register</Typography>
        </Box>
        <Typography variant="body1" align="center">
          Registration functionality coming soon...
        </Typography>
      </Paper>
    </Container>
  );
};

export default RegisterPage;